import { render, staticRenderFns } from "./StakingPledge.vue?vue&type=template&id=bdc06de4&scoped=true"
import script from "./StakingPledge.vue?vue&type=script&lang=js"
export * from "./StakingPledge.vue?vue&type=script&lang=js"
import style0 from "./StakingPledge.vue?vue&type=style&index=0&id=bdc06de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc06de4",
  null
  
)

export default component.exports